/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
 
 /* 
    import default style 
*/

import './src/assets/scss/main.scss'
import './src/assets/scss/pages.scss'
import './src/assets/scss/responsive.scss'
